import React from "react";
import {
  Flex,
  HStack,
  IconButton,
  Image,
  Spacer,
  Stack,
  Divider,
  VStack,
  FlexProps
} from "@chakra-ui/react";
import { IoArrowBack, IoArrowForward } from "react-icons/io5";
import lightLogo from "assets/lightLogo.png";
import { useOnline, useAuth } from "duck";
import { getMenu } from "../../duck";
import NavLink from "../nav-link";

interface SidebarProps extends FlexProps {
  navSize: "sm" | "lg";
  setNavSize?: React.Dispatch<React.SetStateAction<"sm" | "lg">>;
  onClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  navSize,
  setNavSize,
  onClose,
  ...rest
}) => {
  const [{ user }] = useAuth();
  const online = useOnline();

  const handleClick = () => {
    if (setNavSize) {
      setNavSize(prevNavSize => (prevNavSize === "lg" ? "sm" : "lg"));
      return;
    }

    if (onClose) {
      onClose();
    }
  };

  return (
    <Flex backgroundColor="#0B0C10" direction="column" {...rest}>
      <Stack
        as="nav"
        aria-label="Sidebar navigation"
        px={navSize === "lg" ? "6" : "1.188rem"}
        spacing={navSize === "lg" ? "4" : "0.5"}
      >
        {navSize === "lg" ? (
          <HStack justify="space-between" pt="4" pb="6">
            <Image w="122px" h="46px" src={lightLogo} alt="Logo" />
            <IconButton
              aria-label="Collapse sidebar"
              variant="unstyled"
              color="gray.200"
              display="flex"
              icon={<IoArrowBack fontSize="1.625rem" />}
              onClick={handleClick}
            />
          </HStack>
        ) : (
          <VStack spacing="0.813rem" pt={8} mb="1.375rem">
            <IconButton
              aria-label="Expand sidebar"
              variant="unstyled"
              color="gray.200"
              display="flex"
              icon={<IoArrowForward fontSize="1.625rem" />}
              onClick={handleClick}
            />
            <Divider borderColor="gray.200" borderBottomWidth="2px" />
          </VStack>
        )}
        {getMenu(online, user.userRole).map(menuItem => (
          <NavLink
            key={menuItem.key}
            size={navSize}
            label={menuItem.key}
            to={menuItem.to}
            icon={menuItem.icon}
          />
        ))}
      </Stack>
      <Spacer />
    </Flex>
  );
};

export default Sidebar;
